var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "appfade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.appIsLoaded,
            expression: "appIsLoaded"
          }
        ],
        staticClass: "generic-page--template page-template"
      },
      [
        _c("div", { staticClass: "db relative center z-0 w-100 h-auto" }, [
          _c("div", { staticClass: "container-fluid" }, [
            _c("section", { staticClass: "db relative center mw7 pt5 pb5" }, [
              _c("div", { staticClass: "tc" }, [
                _c(
                  "h3",
                  { staticClass: "tc mv4 ttu is-bebas is-white page-title" },
                  [_vm._v(_vm._s(_vm.page.title))]
                )
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "cms-content is-interstate-regular is-white",
                domProps: { innerHTML: _vm._s(_vm.page.content) }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "db relative mw6 center" }, [
                _c(
                  "form",
                  {
                    staticClass: "relative flex flex-column",
                    attrs: {
                      method: "POST",
                      action:
                        "https://formspree.io/themobocraticrepublic@gmail.com"
                    }
                  },
                  [
                    _c("label", { staticClass: "mv1 ttu is-white" }, [
                      _vm._v("Email:")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "mv2 ph2 pv1 w-100 bg-white",
                      attrs: {
                        type: "email",
                        required: "",
                        name: "email",
                        placeholder: "Your email"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { staticClass: "mv1 ttu is-white" }, [
                      _vm._v("Subject:")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "mv2 ph2 pv1 w-100 bg-white",
                      attrs: {
                        type: "text",
                        required: "",
                        name: "subject",
                        placeholder: "Your subject"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { staticClass: "mv1 ttu is-white" }, [
                      _vm._v("Tell Us About Yourself")
                    ]),
                    _vm._v(" "),
                    _c("textarea", {
                      staticClass: "db relative mv2 pv2 h4 w-100 bg-white",
                      staticStyle: { "text-indent": "0.5rem" },
                      attrs: {
                        name: "Tell Us About Yourself",
                        placeholder: "",
                        "data-max": "250",
                        value: "",
                        title: "Tell Us About Yourself",
                        "aria-label": "Enter Text"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "db relative h38px mv3 ph4 tc btn-generic pointer",
                        attrs: { type: "submit" }
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "text f5 ttu is-bebas is-white" },
                          [
                            _vm._v(
                              "\n                  Submit\n                "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }